// extracted by mini-css-extract-plugin
export default {"products":"Bs-z","card":"Cs-z","oosMessaging":"Ds-z"};